import React from 'react'
import IVFBanner from "../components/img/IVFBanner.jpg";
const InVitroFertilizationBanner = () => {
  return (
    <div>
      <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={IVFBanner} className="d-block w-100 carousel-image" alt="..." />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InVitroFertilizationBanner
